import { render, staticRenderFns } from "./ProfileViewStudentInfoCard.vue?vue&type=template&id=0fdb3a34&"
import script from "./ProfileViewStudentInfoCard.vue?vue&type=script&lang=js&"
export * from "./ProfileViewStudentInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports